import styled, { css, keyframes } from 'styled-components';
import { HeaderTitle, HeaderBar } from '../Header/style';

const AlertContainer = styled.div`
  width: 470px;
  height: 460px;
  border-radius: 20px;
  background: #fff;
  position: absolute;
  margin: auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 20px 35px -10px rgba(0, 0, 0, 0.22);
  & ${HeaderBar} {
    margin-top: 50px;
  }
  & ${HeaderTitle} {
    font-size: 26px;
    font-weight: 700;
  }
`;

const AlertClose = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.background.graylight};
  position: absolute;
  top: 20px;
  right: 20px;
  transition: all ease 0.2s;
  cursor: pointer;
  line-height: 35px;
  text-align: center;
  &:hover {
    transform: translateY(-5px);
  }
  &:active {
    transform: translateY(0px);
  }
`;

const AlertContent = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column
  justify-content: center;
  align-items: center;
  & input {
    margin:5px 0;
    padding: 0 20px;
    height: 65px;
  }
`;

const AlertFooter = styled.div`
  width: 100%;
  margin: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const asideanimation = keyframes`
  from { transform: translateX(85px); opacity: 0; }
  to { transform: translateX(0px); opacity: 1; }
`;

const AlertBackground = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0);
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 20%,
    rgba(0, 0, 0, 0.25) 100%
  );
  z-index: 10;
  transition: all ease 0.25s;
  animation: ${asideanimation} 0.25s 0.1s ease backwards;
`;

export {
  AlertContainer,
  AlertBackground,
  AlertClose,
  AlertFooter,
  AlertContent,
};
